@if (showUploadButton) {
  <div [ngStyle]="{ 'margin-top': showTextLink ? '0' : '0.5rem' }">
    @if (!isMobile) {
      @if (!showTextLink) {
        <input
          class="file-input"
          [id]="id"
          type="file"
          [multiple]="multiple"
          (change)="onFileChange($event)" />
        <label [for]="id" [innerHTML]="label"></label>
      }
      @if (showTextLink) {
        <input
          class="text-file-input"
          [id]="id"
          type="file"
          [multiple]="multiple"
          (change)="onFileChange($event)" />
        <label [for]="id" [innerHTML]="label" [ngClass]="textLinkClass"></label>
      }
    }
    @if (isMobile) {
      @if (!showTextLink) {
        <div
          (click)="pickPhotos()"
          class="div-button">
        </div>
      }
      @if (showTextLink) {
        <tidy-text
          [actionBody]="label"
          (action)="pickPhotos()"
          [class]="textLinkClass || 'link'" />
      }
    }
  </div>
}

@if (showPreview) {
  <div style="margin-top: 1rem">
    @if (images.length > 0) {
      <tidy-carrousel [scaleImages]="false" [slidesPerView]="slidesPerView">
        @for (image of images; track image; let i = $index) {
          <ng-container *tidyCarrousel>
            <div class="image-preview-container">
              @if (image?.mediaType === 'photo') {
                <img
                  [src]="image?.url"
                  alt="image"
                  class="file-image-preview"
                  [style.border-radius]="
                    image?.category ||
                    image?.uploadedBy ||
                    image?.uploadedAt ||
                    image?.location
                      ? '6px 6px 0px 0px'
                      : '6px'
                  "
                  [style.width]="
                    images.length === 1 ? '100% !important' : '200px'
                  " />
              }
              @if (image?.mediaType === 'video') {
                <video
                  alt="video"
                  class="file-image-preview video-preview"
                  [style.border-radius]="
                    image?.category ||
                    image?.uploadedBy ||
                    image?.uploadedAt ||
                    image?.location
                      ? '6px 6px 0px 0px'
                      : '6px'
                  "
                  [style.width]="
                    images.length === 1 ? '100% !important' : '200px'
                  "
                  controls>
                  <source [src]="image?.url + '#t=0.001'" type="video/mp4">
                </video>
              }
              @if (
                image?.category ||
                image?.uploadedBy ||
                image?.uploadedAt ||
                image?.location
                ) {
                <div
                  class="file-caption"
                  >
                  @if (image?.category) {
                    <ion-row class="file-caption-row">
                      <tidy-text
                      [body]="('Category:' | translate) + ' ' + image?.category" />
                    </ion-row>
                  }
                  @if (image?.uploadedBy) {
                    <ion-row class="file-caption-row">
                      <tidy-text
                      [body]="('Uploaded by:' | translate) + ' ' + image?.uploadedBy" />
                    </ion-row>
                  }
                  @if (image?.uploadedAt) {
                    <ion-row class="file-caption-row">
                      <tidy-text
                      [body]="('Timestamp:' | translate) + ' ' + image?.uploadedAt" />
                    </ion-row>
                  }
                  @if (image?.location) {
                    <ion-row class="file-caption-row">
                      <tidy-text
                      [body]="('Location:' | translate) + ' ' + image?.location" />
                    </ion-row>
                  }
                </div>
              }
              @if (showDeleteButton) {
                <div
                  class="remove-image-button"
                  (click)="removeImage(i, image)">
                  <button matSuffix mat-icon-button mat-mini-fab>
                    <img
                      src="../../../assets/svg/delete.svg"
                      alt="close icon"
                      class="action-icon" />
                  </button>
                </div>
              }
              @if (showDownloadButton) {
                <div
                  class="download-image-button"
                  (click)="downloadImage(image)">
                  <button matSuffix mat-icon-button mat-mini-fab>
                    <img
                      src="../../../assets/svg/download-icon.svg"
                      alt="download icon"
                      class="action-icon" />
                  </button>
                </div>
              }
            </div>
          </ng-container>
        }
      </tidy-carrousel>
    }
  </div>
}
